<template>
  <v-container fluid mx-0 pa-0>
    <v-row style="max-width: 98%; margin: 0px auto">
      <v-col cols="12" lg="4">
        <div v-if="!B_Loaded" style="margin-top: 20px">
          <div style="width: 100px; margin: 0px auto">
            <v-img src="../../assets/equiload.gif" aspect-ratio="1"></v-img>
          </div>
          <div style="margin-top: 20px">
            <v-row v-if="L_LoadIndice < L_LoadLimit">
              <v-col lg="12" class="pa-1" style="text-align: center; color: #aaa">{{ T_Message }} {{ L_LoadIndice }} / {{ L_LoadLimit }}</v-col>
            </v-row>
            <v-row v-else-if="T_Message != ''">
              <v-col lg="12" class="pa-1" style="text-align: center; color: #aaa">{{ T_Message }}</v-col>
            </v-row>
          </div>
        </div>
        <v-form v-if="B_Loaded" v-model="B_Valid">
          <v-autocomplete
            v-if="B_UserEncoder"
            v-model="L_IssuerID"
            label="Émetteur"
            :items="TO_UserList"
            :item-text="Fct_displayTextIssuer"
            item-value="id"
            :rules="[v => !!v || 'L\'émetteur est requis']"
            @change="Fct_SelectIssuer"
            required
            :readonly="B_ReadOnly"
          ></v-autocomplete>
          <v-autocomplete
            v-model="T_Provider"
            :items="ProvidersList"
            :item-text="Fct_displayTextProvider"
            item-value="equisis_code"
            :rules="[v => !!v || 'Le fournisseur est requis']"
            label="Fournisseur"
            :hint="`Code ${T_Provider}`"
            @change="Fct_SelectProvider"
            persistent-hint
            required
            :readonly="B_ReadOnly"
          ></v-autocomplete>
          <v-text-field v-model="T_Libelle" :rules="T_LibelleRules" :counter="50" label="Libellé de l'offre fournisseur" required :readonly="B_Visu"></v-text-field>
          <v-row>
            <v-col cols="4">
              <v-select
                v-model="T_Period"
                class="mt-2"
                :items="TT_PeriodsList"
                :rules="[v => !!v || 'L\' année est requise']"
                label="Année"
                @change="Fct_SelectPeriod"
                required
                :readonly="B_ReadOnly"
              ></v-select>
            </v-col>
            <v-col cols="8">
              <v-autocomplete
                v-model="T_AnalyticAccount"
                class="mt-2"
                :items="TO_AnalyticAccountList"
                item-text="libelle_CA"
                item-value="cpteAnalytique"
                :rules="[v => !!v || 'Le compte analytique est requis']"
                label="Compte Analytique"
                :hint="`Compte '${T_AnalyticAccount}'`"
                @change="Fct_SelectAccount"
                persistent-hint
                required
                :readonly="B_ReadOnly"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row v-if="TO_budgets.length <= 1" class="ml-0">
            <v-autocomplete
              v-model="T_AnalyticNature"
              class="mb-2"
              :items="TO_AnalyticNatureList"
              :item-text="item => item.libelle_nature + ' - ' + item.natureAnalytique"
              item-value="natureAnalytique"
              :rules="[v => !!v || 'La nature analytique est requise']"
              label="Nature Analytique"
              :hint="`Nature '${T_AnalyticNature}'`"
              @change="Fct_SelectNature"
              persistent-hint
              required
              :readonly="B_ReadOnly"
            ></v-autocomplete>
            <v-btn color="primary" class="mx-3 my-3" icon @click="Fct_showNatures" title="Afficher les natures">
              <v-icon size="36">mdi-plus-circle</v-icon>
            </v-btn>
          </v-row>
          <v-row v-else class="ml-0">
            <v-btn @click="Fct_showNatures" color="primary" class="elevation-2" text>
              Natures multiples
            </v-btn>
          </v-row>
          <v-text-field
            v-model="R_MontantTotal"
            :rules="TO_MontantRules"
            label="Montant total engagé"
            required
            @blur="Fct_MontantFilter"
            @focus="$event.target.select()"
            class="mt-4 mb-2"
            :readonly="B_ReadOnly || this.TO_budgets.length != 1"
          ></v-text-field>
          <v-file-input v-model="O_File" @change="Fct_onFileSelected" label="Sélectionnez un fichier PDF..."></v-file-input>
          <div v-if="T_EditMode != 'Add' && T_previewUrl" class="pb-2">
            Fichier PDF attaché : <a :href="T_previewUrl" color="primary" style="text-decoration: none" target="_blank">Ouvrir</a>
          </div>
          <v-text-field v-model="T_Description" :rules="TO_DescriptionRules" :counter="250" label="Descriptif interne" :readonly="B_Visu"></v-text-field>
          <v-row>
            <v-col cols="4">
              <v-text-field
                v-model="T_DateDisplay"
                label="Date de livraison"
                prepend-icon="mdi-calendar-month"
                @focus="$event.target.select()"
                @click:prepend="Fct_DatePickerOpen"
                @blur="Fct_DateCheck"
                :readonly="B_Visu"
              ></v-text-field>

              <v-dialog v-if="!B_Visu" ref="dialog" v-model="B_DatePicker" persistent width="290px">
                <v-date-picker v-model="T_DateSQL" scrollable locale="fr-fr">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="B_DatePicker = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="Fct_DatePickerSave(T_DateSQL)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>

            <v-col cols="4">
              <v-text-field
                v-model="T_TimeDisplay"
                label="Heure de livraison"
                prepend-icon="mdi-clock-time-four-outline"
                @click:prepend="Fct_TimePickerOpen"
                :readonly="B_Visu"
              ></v-text-field>
              <v-dialog v-if="!B_Visu" ref="dialog" v-model="B_TimePicker" persistent width="290px">
                <v-time-picker v-model="T_TimeSQL" class="mt-4" format="24hr">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="B_TimePicker = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="Fct_TimePickerSave(T_TimeSQL)">OK</v-btn>
                </v-time-picker>
              </v-dialog>
            </v-col>

            <v-col cols="4">
              <v-text-field
                v-model="T_DateDisplayRecall"
                label="Date de reprise"
                prepend-icon="mdi-calendar-month"
                @focus="$event.target.select()"
                @click:prepend="Fct_DatePickerOpenRecall"
                @blur="Fct_DateCheckRecall"
                :readonly="B_Visu"
              ></v-text-field>
              <v-dialog v-if="!B_Visu" ref="dialog" v-model="B_DatePickerRecall" persistent width="290px" :readonly="B_Visu">
                <v-date-picker v-model="T_DateSQLRecall" scrollable locale="fr-fr">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="B_DatePickerRecall = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="Fct_DatePickerSaveRecall(T_DateSQLRecall)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="my-0 py-0">
              <v-select v-model="T_CondPmt" :items="TT_CondPmt" label="Choisir la condition de paiement" @change="Fct_SelectCondPmt" :readonly="B_Visu"></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="my-0 py-0">
              <v-textarea
                rows="2"
                required
                :rules="[v => !!v || 'La condition de paiement est requise']"
                label="Condition de paiement"
                v-model="T_ReadCondPmt"
                :readonly="B_Visu"
              ></v-textarea>
            </v-col>
          </v-row>

          <div v-if="TO_budgets.length <= 1">
            <div v-if="B_BudgetOut" style="color: red; text-align: center">Cet engagement est hors budget (dépassement de {{ this.R_BudgetOver }} €)</div>
          </div>
          <div v-else>
            <ul>
              <li v-for="(budget, index) in filteredBudgets" :key="index" style="color: red">
                Dépassement du budget ({{ budget.code_nature }}) de {{ 0 - budget.montant_restant_budget }} € ;
              </li>
            </ul>
          </div>

          <v-row>
            <v-spacer />
            <v-btn class="my-4 mr-2" color="#444" style="color: #fff" @click="Fct_CancelForm">Annuler</v-btn>
            <v-btn v-if="T_EditMode == 'Add' && !B_Visu" class="my-4 mr-2" color="secondary" @click="Fct_SubmitAddForm">Ajouter</v-btn>
            <v-btn v-if="T_EditMode == 'Mod' && !B_Visu" class="my-4 mr-2" color="#cc0000" style="color: #fff" @click="Fct_DeleteForm">Effacer</v-btn>
            <v-btn v-if="T_EditMode == 'Mod' && !B_Visu" class="my-4 mr-2" color="secondary" @click="Fct_SubmitModForm">Modifier</v-btn>
          </v-row>
        </v-form>
      </v-col>
      <v-col cols="12" lg="4" class="d-none d-lg-flex" style="background: #f2f4f9">
        <v-container>
          <v-row>
            <v-col lg="12" class="pa-1" style="text-align: center">Prévisualisation du Budget</v-col>
          </v-row>
          <v-row v-if="TO_budgets.length > 0">
            <v-col lg="6" class="pa-1">Budget total</v-col>
            <v-col lg="6" class="pa-1" style="text-align: right">{{ R_montantBudgetTotal }}</v-col>
          </v-row>
          <v-row v-else>
            <v-col lg="12" class="pa-1" style="text-align: center; color: #aaa">Veuillez sélectionner un compte et au moins une nature analytique</v-col>
          </v-row>
          <v-row v-if="TO_budgets.length > 0">
            <v-col lg="6" class="pa-1">Restant budget total</v-col>
            <v-col lg="6" class="pa-1" v-if="R_montantBudgetRemaining < 0" style="color: #cc0000; text-align: right">{{ R_montantBudgetRemaining }}</v-col>
            <v-col lg="6" class="pa-1" v-else style="text-align: right">{{ R_montantBudgetRemaining }}</v-col>
          </v-row>
          <v-row v-if="TO_budgets.length > 0">
            <v-col lg="6" class="pa-1">Engagements</v-col>
            <v-col lg="6" class="pa-1" style="text-align: right">{{ L_BudgetsCounter }} <span v-if="T_EditMode == 'Add'">(+1)</span></v-col>
          </v-row>

          <v-row><v-divider class="my-4"></v-divider></v-row>

          <v-row>
            <v-col lg="12" class="pa-1" style="text-align: center">Données pour envoi</v-col>
          </v-row>
          <v-row>
            <v-col cols="5">
              <v-select v-model="T_MailFrnSelect" :items="TT_MailFourn" label="Choisir une adresse" @change="Fct_SelectProviderMail" :readonly="B_Visu"></v-select>
            </v-col>
            <v-col cols="7">
              <v-text-field
                v-model="T_MailFourn"
                label="Adresses mail du fournisseur"
                hint="Exemple : info@info.be; info@info.com; .."
                required
                :readonly="B_Visu"
                autocomplete="off"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-select v-model="T_AdrArdentes" :items="TT_ArdArdentes" label="Choisir l'adresse de livraison" @change="Fct_SelectAdrLiv" :readonly="B_Visu"></v-select>
          </v-row>
          <v-row>
            <v-textarea class=".float-right" rows="3" label="Adresse de livraison" hint="Adresse de livraison" v-model="T_ReadAdrLiv" readonly></v-textarea>
          </v-row>
          <v-row>
            <v-text-field
              v-model="T_NameContact"
              label="Nom du contact sur place"
              hint="Nom de la personne qui sera contactée par le fournisseur"
              :readonly="B_Visu"
            ></v-text-field>
          </v-row>
          <v-row>
            <v-textarea v-model="T_TextIntro" label="Texte d'introduction" hint="Texte ajouté dans le document en pièce jointe du mail" :readonly="B_Visu"></v-textarea>
          </v-row>
          <v-row>
            <v-textarea v-model="T_RemarqueFrn" label="Remarque au Fournisseur" hint="Texte à destination du fournisseur" :readonly="B_Visu"></v-textarea>
          </v-row>
          <v-row>
            <v-checkbox class="my-0 py-0" v-model="L_AddAccessMap" label="Joindre le plan d'accès au mail" :readonly="B_Visu"></v-checkbox>
            <v-checkbox class="my-0 py-0 ml-4" v-model="L_AddCmdFile" label="Joindre l'offre au mail" :readonly="B_Visu"></v-checkbox>
          </v-row>
          <v-row>
            <v-radio-group class="my-0 py-0" v-model="T_LangTemp" row :readonly="B_Visu">
              <v-radio label="Template FR" value="FR"></v-radio>
              <v-radio label="Template NL" value="NL"></v-radio>
            </v-radio-group>
          </v-row>
        </v-container>
      </v-col>
      <v-col cols="12" lg="4" class="pt-0">
        <div v-if="!T_previewUrl" class="drop-area" @dragover.prevent @drop="onDrop" @dragenter="onDragEnter" @dragleave="onDragLeave">
          <v-icon class="icon">mdi-file-upload-outline</v-icon>
          <p class="text">Glissez et déposez un fichier PDF ici</p>
        </div>
        <object v-else type="application/pdf" :data="T_previewUrl" width="100%" height="98%" @dragover.prevent="onDragOver"></object>
      </v-col>
    </v-row>
    <popnatures
      ref="natures"
      :L_EngageID="L_EngageID"
      :R_MontantTotal="parseFloat(R_MontantTotal)"
      :TO_budgets="TO_budgets"
      :TO_AnalyticNatureList="TO_AnalyticNatureList"
      @update:TO_budgets="Fct_UpdateTOBudgets"
    >
    </popnatures>
  </v-container>
</template>

<script>
import { MixinProviders } from "../../mixin/MixinProviders";
import { MixinBudgets } from "../../mixin/MixinBudgets";
import { MixinPeriods } from "../../mixin/MixinPeriods";
import { MixinPrefs } from "../../mixin/MixinPrefs";
import popnatures from "./gestionNatures";

export default {
  mixins: [MixinProviders, MixinBudgets, MixinPeriods, MixinPrefs],
  components: { popnatures },
  props: { T_EditMode: { type: String } },
  data: () => ({
    T_Message: "",
    B_Valid: false,
    L_EngageID: 0,
    L_UserID: 0,
    T_Period: "Loading",
    T_Libelle: "",
    T_LibelleRules: [
      v => !!v || "Le libellé est obligatoire",
      v => v.length <= 50 || "Le libellé doit avoir moins de 50 caractères",
      v => v.length >= 3 || "Le libellé doit avoir au moins 3 caractères"
    ],
    R_MontantTotal: "0.00",
    TO_MontantRules: [v => parseFloat(v) != 0 || "Le montant est obligatoire"],
    L_BudgetID: 0,
    T_Provider: "",
    L_ProviderFKID: 0,
    T_AnalyticAccount: "",
    TO_AnalyticAccountList: [],
    L_AnalyticAccountFKID: 0,
    T_AnalyticNature: "",
    TO_AnalyticNatureList: [],
    L_AnalyticNatureFKID: 0,
    O_File: null,
    B_ModFile: false,
    T_Description: "",
    TO_DescriptionRules: [v => v.length <= 250 || "Le commentaire doit avoir moins de 250 caractères"],
    T_TimeSQL: "00:00",
    T_TimeDisplay: "00:00",
    B_TimePicker: false,
    T_DateSQL: new Date().toISOString().substr(0, 10),
    T_DateDisplay: "",
    B_DatePicker: false,
    T_DateSQLRecall: new Date().toISOString().substr(0, 10),
    T_DateDisplayRecall: "",
    B_DatePickerRecall: false,
    L_Status: 0,
    TB_Loaded: [],
    B_Loaded: false,
    L_LoadIndice: 0,
    L_LoadLimit: 0,
    L_AddTermsConditions: 0,
    L_AddAccessMap: 1,
    L_AddCmdFile: 1,
    T_TextIntro: "",
    T_RemarqueFrn: "",
    T_MailFourn: "",
    TT_MailFourn: [],
    T_MailFrnSelect: "",
    T_NameContact: "",
    T_AdrArdentes: "",
    TT_ArdArdentes: [],
    TL_IdArdArdentes: [],
    TL_defaultArdArdentes: [],
    T_ReadAdrLiv: "",
    T_AdrLiv: "",
    T_CP: "",
    T_Localite: "",
    T_Pays: "",
    B_ReadOnly: false,
    B_Visu: false,
    T_LangTemp: "FR",
    B_SuperAdmin: false,
    B_UserEncoder: false,
    T_previewUrl: "",
    B_isDragging: false,
    T_PmtCond: "1",
    T_CondPmt: "",
    TT_CondPmt: [],
    TL_CondPmt: [],
    T_ReadCondPmt: "",
    TL_defaultCondPmt: [],
    B_UsersLoaded: false,
    TO_UserList: [],
    L_IssuerID: 0,

    TO_budgets: [
      {
        fk_engagement: 0,
        fk_budget: 0,
        fk_NatureAnalytique: 0,
        code_nature: "",
        montant: 0,
        montant_budget: 0,
        montant_restant_budget: 0,
        engagements_count_budget: 0,
        engagements_pk_budget: []
      }
    ],
    R_montantBudgetTotal: 0,
    R_montantBudgetRemaining: 0,

    L_DuplicataID: 0
  }),
  computed: {
    B_BudgetOut: function() {
      return this.R_montantBudgetRemaining < 0;
    },
    R_BudgetOver: function() {
      return 0 - this.R_montantBudgetRemaining;
    },
    filteredBudgets: function() {
      return this.TO_budgets.filter(function(budget) {
        return budget.montant_restant_budget < 0;
      });
    }
  },
  methods: {
    Fct_showNatures() {
      this.$refs.natures.show();
    },
    Fct_UpdateTOBudgets(updatedBudgets) {
      this.TO_budgets = updatedBudgets;

      this.R_MontantTotal = 0;
      this.L_BudgetsCounter = 0;
      this.R_montantBudgetTotal = 0;
      this.R_montantBudgetRemaining = 0;
      var engagementsPkSet = new Set();

      for (var L_Index = 0; L_Index < this.TO_budgets.length; L_Index++) {
        this.R_MontantTotal += parseFloat(this.TO_budgets[L_Index].montant);
        this.R_montantBudgetTotal += parseFloat(this.TO_budgets[L_Index].montant_budget);
        this.R_montantBudgetRemaining += parseFloat(this.TO_budgets[L_Index].montant_restant_budget);
        var engagementsPk = this.TO_budgets[L_Index].engagements_pk_budget;
        engagementsPk.forEach(pk => engagementsPkSet.add(pk));
      }

      this.R_MontantTotal = this.R_MontantTotal.toFixed(2);
      this.L_BudgetsCounter = engagementsPkSet.size;
      this.R_montantBudgetTotal = this.R_montantBudgetTotal.toFixed(2);
      this.R_montantBudgetRemaining = this.R_montantBudgetRemaining.toFixed(2);

      if (this.TO_budgets.length == 1) {
        this.L_BudgetID = this.TO_budgets[0].fk_budget;
        this.T_AnalyticNature = this.TO_budgets[0].code_nature;
        this.Fct_SelectNature();
      } else {
        this.L_BudgetID = 0;
        this.L_AnalyticNatureFKID = 0;
        this.T_AnalyticNature = "";
      }
    },
    Fct_displayTextProvider(item) {
      var displayText = `${item.company_name} (${item.equisis_code})`;
      if (item.vat_number && item.vat_number.trim() !== "") {
        displayText = displayText + ` [${item.vat_number}]`;
      }
      return displayText;
    },
    Fct_displayTextIssuer(item) {
      var displayText = `${item.first_name} ${item.last_name} (${item.email})`;
      return displayText;
    },
    Fct_getTimeAsStr() {
      var myDate = new Date();
      return (myDate.getHours() + ":" + myDate.getMinutes()).toString();
    },
    Fct_Loading() {
      // vérifie l'avancement du chargement de la page
      if (!this.B_UsersLoaded) {
        this.T_Message = "Chargement des utilisateurs";
      } else if (!this.ProvidersLoaded) {
        this.T_Message = "Chargement des fournisseurs";
      } else if (!this.B_BudgetsLoaded) {
        this.T_Message = "Chargement des budgets";
      } else {
        this.B_Loaded = true;
      }

      if (this.B_Loaded) {
        this.Fct_Launch();
        this.T_Message = "";
      } else {
        setTimeout(this.Fct_Loading, 500);
      }
    },
    Fct_GetUsers() {
      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .get("user/", { headers: { Authorization: T_Token } })
        .then(response => {
          this.TO_UserList = response.data;
          this.B_UsersLoaded = true;
        })
        .catch(() => {
          this.$router.push({ name: "Disconnect" });
        });
    },
    Fct_MontantFilter() {
      const self = this;
      if (this.R_MontantTotal == "") {
        this.R_MontantTotal = "0.00";
      } else {
        this.R_MontantTotal = this.R_MontantTotal.replace(",", ".");
        this.R_MontantTotal = parseFloat(this.R_MontantTotal).toFixed(2);
      }
      this.BudgetsHowFarOut(this.L_BudgetID, this.R_MontantTotal, this.L_EngageID).then(function() {
        if (self.TO_budgets.length == 1) {
          self.TO_budgets[0].montant = self.R_MontantTotal;
          self.TO_budgets[0].montant_budget = self.R_montantBudgetTotal;
          self.TO_budgets[0].montant_restant_budget = self.R_montantBudgetRemaining;
        }
      });
    },
    Fct_SubmitAddForm() {
      /*if (!this.BudgetsAllowed) {
        this.$root.$children[0].IsisInfo("Vous n'avez pas le droit d'engager d'engagement sur ce budget", "error");
      } else*/
      if (this.Fct_CheckData()) {
        let O_FormData = new FormData();
        O_FormData.append("referenceInterne", "");
        O_FormData.append("libelle", this.T_Libelle);
        O_FormData.append("dateEngagement", this.IsisFct_Date2String(new Date()));
        O_FormData.append("montantTotal", this.R_MontantTotal);
        O_FormData.append("horsBudget", this.B_BudgetOut);
        O_FormData.append("descriptif", this.T_Description);
        O_FormData.append("dateLivraison", this.T_DateSQL);
        O_FormData.append("heureLivraison", this.T_TimeSQL);
        O_FormData.append("fk_CpteAnalytique", this.L_AnalyticAccountFKID);
        O_FormData.append("fk_Statut", 1);
        O_FormData.append("fk_Fournisseur", this.L_ProviderFKID);
        O_FormData.append("fk_UserEngagement", this.L_UserID);
        O_FormData.append("fk_UserIssuer", this.L_IssuerID);
        O_FormData.append("commentaireApprobateur", "");
        O_FormData.append("dateEnvoiMail", "");
        O_FormData.append("dateReprise", this.T_DateSQLRecall);
        O_FormData.append("texteIntro", this.T_TextIntro);
        O_FormData.append("remarqueFrn", this.T_RemarqueFrn);
        O_FormData.append("conditionGen", this.L_AddTermsConditions);
        O_FormData.append("planAcces", this.L_AddAccessMap);
        O_FormData.append("cmdFile", this.L_AddCmdFile);
        O_FormData.append("mailFrn", this.T_MailFourn);
        O_FormData.append("contactSurPlace", this.T_NameContact);
        O_FormData.append("livAddress", this.T_AdrLiv);
        O_FormData.append("livCity", this.T_Localite);
        O_FormData.append("livPostal_code", this.T_CP);
        O_FormData.append("livCountry", this.T_Pays);
        O_FormData.append("dateApprobation", "");
        O_FormData.append("fk_UserApprobation", 0);
        O_FormData.append("langueTemplate", this.T_LangTemp);
        O_FormData.append("pmtCond", parseInt(this.T_PmtCond));
        O_FormData.append("pmtCondOther", this.T_ReadCondPmt);
        O_FormData.append("livAddressPrefId", this.L_id);
        O_FormData.append("duplicataID", this.L_DuplicataID);

        //O_FormData.append("fk_Budget", this.L_BudgetID);
        //O_FormData.append("fk_NatureAnalytique", this.L_AnalyticNatureFKID);

        O_FormData.append("budgets", JSON.stringify(this.TO_budgets));

        if (this.B_ModFile) {
          O_FormData.append("file", this.O_File);
        }

        var T_Token = "JWT " + this.$cookies.get("BackEndToken");
        this.$BackEndAPI
          .post("engagements/", O_FormData, { headers: { Authorization: T_Token } })
          .then(O_Response => {
            if (O_Response != null) {
              this.Fct_CancelForm();
            }
          })
          .catch(O_Error => {
            this.$root.$children[0].IsisInfo(O_Error.message, "error");
          });
      }
    },
    Fct_SubmitModForm() {
      /*if (!this.BudgetsAllowed) {
        this.$root.$children[0].IsisInfo("Vous n'avez pas le droit de modifier cet engagement (autorisation requise)", "error");
      } else*/
      if (this.L_Status >= 4 && this.B_SuperAdmin == false) {
        this.$root.$children[0].IsisInfo("Vous n'avez pas le droit de modifier cet engagement (déjà envoyé)", "error");
      } else if (this.Fct_CheckData()) {
        let O_FormData = new FormData();
        O_FormData.append("libelle", this.T_Libelle);
        O_FormData.append("montantTotal", this.R_MontantTotal);
        O_FormData.append("horsBudget", this.B_BudgetOut);
        O_FormData.append("descriptif", this.T_Description);
        O_FormData.append("dateLivraison", this.T_DateSQL);
        O_FormData.append("heureLivraison", this.T_TimeSQL);
        O_FormData.append("fk_CpteAnalytique", this.L_AnalyticAccountFKID);
        O_FormData.append("fk_Statut", this.L_Status);
        O_FormData.append("fk_Fournisseur", this.L_ProviderFKID);
        O_FormData.append("fk_UserEngagement", this.L_UserID);
        O_FormData.append("fk_UserIssuer", this.L_IssuerID);
        O_FormData.append("commentaireApprobateur", "");
        O_FormData.append("dateReprise", this.T_DateSQLRecall);
        O_FormData.append("texteIntro", this.T_TextIntro);
        O_FormData.append("remarqueFrn", this.T_RemarqueFrn);
        O_FormData.append("conditionGen", this.L_AddTermsConditions);
        O_FormData.append("planAcces", this.L_AddAccessMap);
        O_FormData.append("cmdFile", this.L_AddCmdFile);
        O_FormData.append("mailFrn", this.T_MailFourn);
        O_FormData.append("contactSurPlace", this.T_NameContact);
        O_FormData.append("livAddress", this.T_AdrLiv);
        O_FormData.append("livCity", this.T_Localite);
        O_FormData.append("livPostal_code", this.T_CP);
        O_FormData.append("livCountry", this.T_Pays);
        O_FormData.append("dateApprobation", "");
        O_FormData.append("fk_UserApprobation", 0);
        O_FormData.append("langueTemplate", this.T_LangTemp);
        O_FormData.append("pmtCond", parseInt(this.T_PmtCond));
        O_FormData.append("pmtCondOther", this.T_ReadCondPmt);
        O_FormData.append("livAddressPrefId", this.L_id);

        //O_FormData.append("fk_Budget", this.L_BudgetID);
        //O_FormData.append("fk_NatureAnalytique", this.L_AnalyticNatureFKID);

        O_FormData.append("budgets", JSON.stringify(this.TO_budgets));

        if (this.B_ModFile) {
          O_FormData.append("file", this.O_File);
        }

        var T_Token = "JWT " + this.$cookies.get("BackEndToken");
        this.$BackEndAPI
          .patch("engagements/" + this.L_EngageID + "/", O_FormData, { headers: { Authorization: T_Token } })
          .then(O_Response => {
            if (O_Response != null) {
              this.Fct_CancelForm();
            }
          })
          .catch(O_Error => {
            this.$root.$children[0].IsisInfo(O_Error.message, "error");
          });
      }
    },
    Fct_DeleteForm() {
      const self = this;
      this.$root.$children[0]
        .IsisConfirm("Confirmez-vous la suppression de cet engagement ?")
        .then(O_Response => {
          if (O_Response) {
            // l'utilisateur a validé
            var T_Token = "JWT " + self.$cookies.get("BackEndToken");
            self.$BackEndAPI
              .delete("engagements/" + self.L_EngageID + "/", { headers: { Authorization: T_Token } })
              .then(O_Response => {
                if (O_Response != null) {
                  self.Fct_CancelForm();
                }
              })
              .catch(O_Error => {
                self.$root.$children[0].IsisInfo(O_Error.message, "error");
              });
          } else {
            // l'utilisateur a annulé
            //...
          }
        })
        .catch(O_Error => {
          this.$root.$children[0].IsisInfo(O_Error.message, "error");
        });
    },
    Fct_CancelForm() {
      this.$router.push({ name: "Engagement" });
    },
    Fct_CheckData() {
      if (this.T_Libelle == "") {
        this.$root.$children[0].IsisInfo("Vous devez renseigner un libellé", "error");
        return false;
      }

      if (this.T_Provider == "") {
        this.$root.$children[0].IsisInfo("Vous devez renseigner un fournisseur", "error");
        return false;
      }

      if (this.R_MontantTotal <= 0) {
        this.$root.$children[0].IsisInfo("Vous devez renseigner un montant", "error");
        return false;
      }

      /*if (this.L_BudgetID == 0) {
        this.$root.$children[0].IsisInfo("Vous devez renseigner compte et nature analytique", "error");
        return false;
      }*/

      if (this.T_TextIntro == "") {
        this.$root.$children[0].IsisInfo("Vous devez renseigner un texte d'introduction", "error");
        return false;
      }

      if (this.T_EditMode == "Add" && this.L_DuplicataID == 0) {
        if (this.O_File == null) {
          this.$root.$children[0].IsisInfo("Vous devez renseigner un fichier", "error");
          return false;
        }
      }

      if (this.T_AdrLiv == "") {
        this.$root.$children[0].IsisInfo("Vous devez choisir une adresse de livraison", "error");
        return false;
      }

      if (this.T_MailFourn == "") {
        this.$root.$children[0].IsisInfo("Vous devez saisir l'adresse mail du fournisseur", "error");
        return false;
      }

      if (this.T_LangTemp == "") {
        this.$root.$children[0].IsisInfo("Vous devez choisir le langue du template", "error");
        return false;
      }

      /*if (this.T_PmtCond == "2") {
        if (this.T_PmtCondOther == "") {
          this.$root.$children[0].IsisInfo("Vous devez spécifier une condition de paiement", "error");
          return false;
        }
      }*/

      /*if (this.T_RemarqueFrn == "") {
        this.$root.$children[0].IsisInfo("Vous devez saisir une remarque fournisseur", "error");
        return false;
      }*/

      return true;
    },
    Fct_Launch() {
      this.TO_AnalyticAccountList = this.TO_BudgetsList;

      if (this.ProvidersList.length == 0) {
        this.$root.$children[0].IsisInfo("Aucun fournisseur n'est présent dans cette base de données, ce qui empêche l'ajout d'engagements.", "error");
        this.$router.push({ name: "Engagement" });
      }

      if (this.T_EditMode == "Add") {
        if (this.L_DuplicataID > 0) {
          // duplication d'un engagement
          var T_Token = "JWT " + this.$cookies.get("BackEndToken");
          this.$BackEndAPI
            .get("engagements/" + this.L_DuplicataID, { headers: { Authorization: T_Token } })
            .then(response => {
              var O_Engagement = response.data;

              //this.O_File = O_Engagement.file;
              //this.T_File = O_Engagement.file;
              this.T_previewUrl = O_Engagement.file;

              this.T_Provider = O_Engagement.code_frn;
              this.T_Libelle = O_Engagement.libelle;
              this.T_Description = O_Engagement.descriptif;
              this.T_DateSQL = O_Engagement.dateLivraison;
              this.T_DateDisplay = this.IsisFct_Date2Display(this.T_DateSQL);
              this.T_TimeSQL = O_Engagement.heureLivraison;
              this.T_TimeDisplay = this.T_TimeSQL;
              this.T_DateSQLRecall = O_Engagement.dateReprise;
              this.T_DateDisplayRecall = this.IsisFct_Date2Display(this.T_DateSQLRecall);
              //this.L_Status = O_Engagement.fk_Statut;
              this.L_ProviderFKID = O_Engagement.fk_Fournisseur;
              this.L_AddTermsConditions = O_Engagement.conditionGen;
              this.L_AddAccessMap = O_Engagement.planAcces;
              this.L_AddCmdFile = O_Engagement.cmdFile;
              this.T_TextIntro = O_Engagement.texteIntro;
              this.T_RemarqueFrn = O_Engagement.remarqueFrn;
              this.T_MailFourn = O_Engagement.mailFrn;
              this.T_NameContact = O_Engagement.contactSurPlace;
              this.T_LangTemp = O_Engagement.langueTemplate;
              this.T_PmtCond = O_Engagement.pmtCond.toString();
              this.T_ReadCondPmt = O_Engagement.pmtCondOther;
              this.L_id = O_Engagement.livAddressPrefId;
              this.T_AdrLiv = O_Engagement.livAddress;
              this.T_Localite = O_Engagement.livCity;
              this.T_CP = O_Engagement.livPostal_code;
              this.T_Pays = O_Engagement.livCountry;
              this.T_ReadAdrLiv = this.T_AdrLiv + "\n";
              this.T_ReadAdrLiv += this.T_CP + "  " + this.T_Localite + "\n";
              this.T_ReadAdrLiv += this.T_Pays;
              this.L_IssuerID = O_Engagement.fk_UserIssuer;

              //this.L_BudgetID = O_Engagement.fk_Budget;
              //this.T_AnalyticNature = O_Engagement.code_nature;
              //this.Fct_SelectNature();

              //this.R_MontantTotal = O_Engagement.montantTotal;

              this.T_AnalyticAccount = O_Engagement.code_CA;
              this.Fct_SelectAccount();

              this.TO_budgets = O_Engagement.budgets;
              this.TO_budgets.forEach(budget => {
                budget.id = 0;
                budget.montant = 0;
                budget.consomme = 0;
              });

              this.L_BudgetsCounter = 0;
              this.R_montantBudgetTotal = 0;
              this.R_montantBudgetRemaining = 0;
              var engagementsPkSet = new Set();

              for (var L_Index = 0; L_Index < this.TO_budgets.length; L_Index++) {
                this.R_montantBudgetTotal += parseFloat(this.TO_budgets[L_Index].montant_budget);
                this.R_montantBudgetRemaining += parseFloat(this.TO_budgets[L_Index].montant_restant_budget);
                var engagementsPk = this.TO_budgets[L_Index].engagements_pk_budget;
                engagementsPk.forEach(pk => engagementsPkSet.add(pk));
              }

              this.L_BudgetsCounter = engagementsPkSet.size;
              this.R_montantBudgetTotal = this.R_montantBudgetTotal.toFixed(2);
              this.R_montantBudgetRemaining = this.R_montantBudgetRemaining.toFixed(2);

              if (this.TO_budgets.length == 1) {
                this.L_BudgetID = this.TO_budgets[0].fk_budget;
                this.T_AnalyticNature = this.TO_budgets[0].code_nature;
                this.Fct_SelectNature();
              } else {
                this.L_BudgetID = 0;
                this.L_AnalyticNatureFKID = 0;
                this.T_AnalyticNature = "";
              }

              this.Fct_SelectProvider();
            })
            .catch(() => {
              this.$router.push({ name: "Disconnect" });
            });
        } else {
          // création d'un nouvel engagement
          this.T_TextIntro = this.Fct_PrefsGetString("PrefTextIntro", "");

          // select default encoder (user logged in)
          this.L_IssuerID = this.L_UserID;
          if (this.B_UserEncoder) {
            if (this.TO_UserList.length > 0) {
              for (var L_Index = 0; L_Index < this.TO_UserList.length; L_Index++) {
                if (this.TO_UserList[L_Index].id == this.L_UserID) {
                  this.L_IssuerID = this.TO_UserList[L_Index].id;
                  this.Fct_SelectIssuer();
                }
              }
            }
          }

          // select default analytical account
          if (this.TO_AnalyticAccountList.length > 0) {
            var distinctValues = [...new Set(this.TO_AnalyticAccountList.map(item => item.cpteAnalytique))];
            if (distinctValues.length === 1) {
              this.T_AnalyticAccount = distinctValues[0];
              this.Fct_SelectAccount();
            }
          }

          // select default payment condition
          if (this.TL_defaultCondPmt.length > 0) {
            for (L_Index = 0; L_Index < this.TL_defaultCondPmt.length; L_Index++) {
              if (this.TL_defaultCondPmt[L_Index] == true) {
                this.T_CondPmt = this.TT_CondPmt[L_Index];
                this.Fct_SelectCondPmt();
              }
            }
          }

          // select default address
          if (this.TL_defaultArdArdentes.length > 0) {
            for (L_Index = 0; L_Index < this.TL_defaultArdArdentes.length; L_Index++) {
              if (this.TL_defaultArdArdentes[L_Index] == true) {
                this.T_AdrArdentes = this.TT_ArdArdentes[L_Index];
                this.Fct_SelectAdrLiv();
              }
            }
          }
        }
      } else if (this.T_EditMode == "Mod") {
        // modification d'un engagement
        this.L_EngageID = parseInt(this.$route.params.id);
        T_Token = "JWT " + this.$cookies.get("BackEndToken");
        this.$BackEndAPI
          .get("engagements/" + this.L_EngageID, { headers: { Authorization: T_Token } })
          .then(response => {
            var O_Engagement = response.data;

            //this.O_File = O_Engagement.file;
            //this.T_File = O_Engagement.file;
            this.T_previewUrl = O_Engagement.file;

            this.T_Provider = O_Engagement.code_frn;
            this.T_Libelle = O_Engagement.libelle;
            this.T_Description = O_Engagement.descriptif;
            this.T_DateSQL = O_Engagement.dateLivraison;
            this.T_DateDisplay = this.IsisFct_Date2Display(this.T_DateSQL);
            this.T_TimeSQL = O_Engagement.heureLivraison;
            this.T_TimeDisplay = this.T_TimeSQL;
            this.T_DateSQLRecall = O_Engagement.dateReprise;
            this.T_DateDisplayRecall = this.IsisFct_Date2Display(this.T_DateSQLRecall);
            this.L_Status = O_Engagement.fk_Statut;
            this.L_ProviderFKID = O_Engagement.fk_Fournisseur;
            this.L_AddTermsConditions = O_Engagement.conditionGen;
            this.L_AddAccessMap = O_Engagement.planAcces;
            this.L_AddCmdFile = O_Engagement.cmdFile;
            this.T_TextIntro = O_Engagement.texteIntro;
            this.T_RemarqueFrn = O_Engagement.remarqueFrn;
            this.T_MailFourn = O_Engagement.mailFrn;
            this.T_NameContact = O_Engagement.contactSurPlace;
            this.T_LangTemp = O_Engagement.langueTemplate;
            this.T_PmtCond = O_Engagement.pmtCond.toString();
            this.T_ReadCondPmt = O_Engagement.pmtCondOther;
            this.L_id = O_Engagement.livAddressPrefId;
            this.T_AdrLiv = O_Engagement.livAddress;
            this.T_Localite = O_Engagement.livCity;
            this.T_CP = O_Engagement.livPostal_code;
            this.T_Pays = O_Engagement.livCountry;
            this.T_ReadAdrLiv = this.T_AdrLiv + "\n";
            this.T_ReadAdrLiv += this.T_CP + "  " + this.T_Localite + "\n";
            this.T_ReadAdrLiv += this.T_Pays;
            this.L_IssuerID = O_Engagement.fk_UserIssuer;

            //this.L_BudgetID = O_Engagement.fk_Budget;
            //this.T_AnalyticNature = O_Engagement.code_nature;
            //this.Fct_SelectNature();

            this.R_MontantTotal = O_Engagement.montantTotal;

            this.T_AnalyticAccount = O_Engagement.code_CA;
            this.Fct_SelectAccount();

            this.TO_budgets = O_Engagement.budgets;

            this.L_BudgetsCounter = 0;
            this.R_montantBudgetTotal = 0;
            this.R_montantBudgetRemaining = 0;
            var engagementsPkSet = new Set();

            for (var L_Index = 0; L_Index < this.TO_budgets.length; L_Index++) {
              this.R_montantBudgetTotal += parseFloat(this.TO_budgets[L_Index].montant_budget);
              this.R_montantBudgetRemaining += parseFloat(this.TO_budgets[L_Index].montant_restant_budget);
              var engagementsPk = this.TO_budgets[L_Index].engagements_pk_budget;
              engagementsPk.forEach(pk => engagementsPkSet.add(pk));
            }

            this.L_BudgetsCounter = engagementsPkSet.size;
            this.R_montantBudgetTotal = this.R_montantBudgetTotal.toFixed(2);
            this.R_montantBudgetRemaining = this.R_montantBudgetRemaining.toFixed(2);

            if (this.TO_budgets.length == 1) {
              this.L_BudgetID = this.TO_budgets[0].fk_budget;
              this.T_AnalyticNature = this.TO_budgets[0].code_nature;
              this.Fct_SelectNature();
            } else {
              this.L_BudgetID = 0;
              this.L_AnalyticNatureFKID = 0;
              this.T_AnalyticNature = "";
            }

            switch (O_Engagement.fk_Statut) {
              case 1:
                //A approuver
                this.B_ReadOnly = false;
                this.B_Visu = false;
                break;
              case 2:
                //En demande
                this.B_ReadOnly = true;
                this.B_Visu = false;
                break;
              case 3:
                //Approuvé
                this.B_ReadOnly = true;
                this.B_Visu = false;
                break;
              case 4:
                //Refusé
                this.B_ReadOnly = true;
                this.B_Visu = true;
                break;
              case 5:
                //Envoyé
                this.B_ReadOnly = true;
                this.B_Visu = true;
                break;
              default:
                this.B_ReadOnly = false;
                this.B_Visu = false;
                break;
            }

            if (this.B_SuperAdmin == true) {
              this.B_ReadOnly = false;
              this.B_Visu = false;
            }

            this.Fct_SelectProvider();
          })
          .catch(() => {
            this.$router.push({ name: "Disconnect" });
          });
      }
    },
    Fct_SelectProviderMail() {
      if (this.T_MailFourn != "") {
        this.T_MailFourn += "; ";
      }
      this.T_MailFourn += this.T_MailFrnSelect;
    },
    Fct_SelectPeriod() {
      this.L_BudgetID = 0;

      this.L_BudgetsCounter = 0;
      this.R_montantBudgetTotal = 0;
      this.R_montantBudgetRemaining = 0;

      this.TO_AnalyticAccountList = this.BudgetsFilterGetByPeriodYear(this.T_Period);
      this.L_AnalyticAccountFKID = 0;
      this.T_AnalyticAccount = "";

      this.TO_AnalyticNatureList = [];
      this.L_AnalyticNatureFKID = 0;
      this.T_AnalyticNature = "";

      this.TO_budgets = [
        {
          fk_engagement: 0,
          fk_budget: 0,
          fk_NatureAnalytique: 0,
          code_nature: "",
          montant: 0,
          montant_budget: 0,
          montant_restant_budget: 0,
          engagements_count_budget: 0,
          engagements_pk_budget: []
        }
      ];
    },
    Fct_SelectAccount() {
      this.L_BudgetID = 0;
      this.L_BudgetsCounter = 0;
      this.R_montantBudgetTotal = 0;
      this.R_montantBudgetRemaining = 0;

      this.L_AnalyticAccountFKID = this.BudgetsGetFKAccount(this.T_AnalyticAccount);
      this.TO_AnalyticNatureList = this.BudgetsFilterGetByPeriodYearAccount(this.T_Period, this.T_AnalyticAccount);

      this.L_AnalyticNatureFKID = 0;
      this.T_AnalyticNature = "";

      this.TO_budgets = [
        {
          fk_engagement: 0,
          fk_budget: 0,
          fk_NatureAnalytique: 0,
          code_nature: "",
          montant: 0,
          montant_budget: 0,
          montant_restant_budget: 0,
          engagements_count_budget: 0,
          engagements_pk_budget: []
        }
      ];
    },
    Fct_SelectNature() {
      const self = this;
      this.L_AnalyticNatureFKID = this.BudgetsGetFKNature(this.T_AnalyticNature);
      this.L_BudgetID = this.BudgetsGetIDFromNature(this.T_AnalyticNature, this.TO_AnalyticNatureList);
      this.BudgetsHowFarOut(this.L_BudgetID, this.R_MontantTotal, this.L_EngageID).then(function() {
        if (self.TO_budgets.length == 1) {
          self.TO_budgets[0].fk_budget = self.L_BudgetID;
          self.TO_budgets[0].fk_NatureAnalytique = self.L_AnalyticNatureFKID;
          self.TO_budgets[0].code_nature = self.T_AnalyticNature;
          self.TO_budgets[0].montant = self.R_MontantTotal;
          self.TO_budgets[0].montant_budget = self.R_montantBudgetTotal;
          self.TO_budgets[0].montant_restant_budget = self.R_montantBudgetRemaining;
          self.TO_budgets[0].engagements_count_budget = self.L_BudgetsCounter;
          self.TO_budgets[0].engagements_pk_budget = [];
        }
      });
      this.BudgetsIsAllowed(this.L_BudgetID, this.L_UserID);
    },
    Fct_SelectProvider() {
      this.L_ProviderFKID = this.ProvidersGetFKID(this.T_Provider);

      this.T_MailFrnSelect = "";
      this.TT_MailFourn = [];

      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .get("mailtier/?fk_Fournisseur=" + this.L_ProviderFKID, { headers: { Authorization: T_Token } })
        .then(TO_Response => {
          if (TO_Response != null) {
            var TO_Data = TO_Response.data;
            if (TO_Data != undefined) {
              for (var L_Index = 0; L_Index < TO_Data.length; L_Index++) {
                var T_Mail = TO_Data[L_Index].email;
                this.TT_MailFourn.push(T_Mail);
              }
            }
          }
        })
        .catch(O_Error => {
          this.$root.$children[0].IsisInfo("Tiers Mail : Problème DB - " + O_Error.message, "error");
        });
    },
    Fct_SelectIssuer() {
      //
    },
    Fct_TimePickerOpen() {
      this.B_TimePicker = true;
    },
    Fct_TimePickerSave() {
      this.T_TimeDisplay = this.T_TimeSQL;
      this.B_TimePicker = false;
    },
    Fct_DatePickerOpen() {
      //alert('Date');
      this.B_DatePicker = true;
    },
    Fct_DateCheck() {
      this.T_DateDisplay = this.IsisFct_DateCheck(this.T_DateDisplay);
      this.T_DateSQL = this.IsisFct_Date2SQL(this.T_DateDisplay);
    },
    Fct_DatePickerSave() {
      //alert('Date');
      //$refs.dialog.save(this.T_DateSQL)
      this.T_DateDisplay = this.IsisFct_Date2Display(this.T_DateSQL);
      this.B_DatePicker = false;
    },
    Fct_DatePickerOpenRecall() {
      //alert('Date');
      this.B_DatePickerRecall = true;
    },
    Fct_DateCheckRecall() {
      this.T_DateDisplayRecall = this.IsisFct_DateCheck(this.T_DateDisplayRecall);
      this.T_DateSQLRecall = this.IsisFct_Date2SQL(this.T_DateDisplayRecall);
    },
    Fct_DatePickerSaveRecall() {
      //alert('Date');
      //$refs.dialog.save(this.T_DateSQL)
      this.T_DateDisplayRecall = this.IsisFct_Date2Display(this.T_DateSQLRecall);

      this.B_DatePickerRecall = false;
    },
    Fct_GetAdr() {
      this.T_AdrArdentes = "";
      this.TT_ArdArdentes = [];
      this.TL_IdArdArdentes = [];
      this.TL_defaultArdArdentes = [];
      this.T_ReadAdrLiv = "";
      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .get("preferences/?search=Adr_", { headers: { Authorization: T_Token } })
        .then(TO_Response => {
          if (TO_Response != null) {
            var TO_Data = TO_Response.data;
            if (TO_Data != undefined) {
              for (var L_Index = 0; L_Index < TO_Data.length; L_Index++) {
                var T_AdrArdentes = TO_Data[L_Index].libelle;
                this.TT_ArdArdentes.push(T_AdrArdentes);
                this.TL_IdArdArdentes.push(TO_Data[L_Index].id);
                this.TL_defaultArdArdentes.push(TO_Data[L_Index].default);
              }
            }
          }
        })
        .catch(O_Error => {
          this.$root.$children[0].IsisInfo("Problème DB - " + O_Error.message, "error");
        });
    },
    Fct_SelectAdrLiv() {
      var index = this.TT_ArdArdentes.indexOf(this.T_AdrArdentes);
      this.L_id = this.TL_IdArdArdentes[index];
      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .get("preferences/" + this.L_id + "/", { headers: { Authorization: T_Token } })
        .then(TO_Response => {
          if (TO_Response != null) {
            this.T_ReadAdrLiv = TO_Response.data.address + "\n";
            this.T_ReadAdrLiv += TO_Response.data.postal_code + "  " + TO_Response.data.city + "\n";
            this.T_ReadAdrLiv += TO_Response.data.country;
            this.T_AdrLiv = TO_Response.data.address;
            this.T_CP = TO_Response.data.postal_code;
            this.T_Localite = TO_Response.data.city;
            this.T_Pays = TO_Response.data.country;
          }
        })
        .catch(O_Error => {
          this.$root.$children[0].IsisInfo(" Problème DB - " + O_Error.message, "error");
        });
    },
    Fct_GetCondPmt() {
      this.T_CondPmt = "";
      this.TT_CondPmt = [];
      this.TL_CondPmt = [];
      this.TL_defaultCondPmt = [];
      this.T_ReadCondPmt = "";
      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .get("preferences/?search=CondPmt_", { headers: { Authorization: T_Token } })
        .then(TO_Response => {
          if (TO_Response != null) {
            var TO_Data = TO_Response.data;
            if (TO_Data != undefined) {
              for (var L_Index = 0; L_Index < TO_Data.length; L_Index++) {
                this.TT_CondPmt.push(TO_Data[L_Index].libelle);
                this.TL_CondPmt.push(TO_Data[L_Index].id);
                this.TL_defaultCondPmt.push(TO_Data[L_Index].default);
              }
            }
          }
        })
        .catch(O_Error => {
          this.$root.$children[0].IsisInfo("Problème DB - " + O_Error.message, "error");
        });
    },
    Fct_SelectCondPmt() {
      var index = this.TT_CondPmt.indexOf(this.T_CondPmt);
      this.L_id2 = this.TL_CondPmt[index];
      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .get("preferences/" + this.L_id2 + "/", { headers: { Authorization: T_Token } })
        .then(TO_Response => {
          if (TO_Response != null) {
            this.T_ReadCondPmt = TO_Response.data.value;
          }
        })
        .catch(O_Error => {
          this.$root.$children[0].IsisInfo(" Problème DB - " + O_Error.message, "error");
        });
    },
    Fct_onFileSelected() {
      this.B_ModFile = true;
      if (this.O_File) {
        this.Fct_previewFile(this.O_File);
      } else {
        this.T_previewUrl = ""; // Efface la prévisualisation si aucun fichier n'est sélectionné
      }

      /*if (this.T_EditMode == "Mod") {
        this.B_ModFile = true;
        //this.$root.$children[0].IsisInfo("Veuillez enregistrer l'engagement pour voir les modifications", "success");
      }*/
    },
    Fct_previewFile(file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.T_previewUrl = reader.result;
      };
      reader.readAsDataURL(file);
    },
    onDrop(event) {
      this.B_isDragging = false;
      event.preventDefault();
      this.B_ModFile = true;
      this.O_File = event.dataTransfer.files[0];
      this.Fct_previewFile(this.O_File);
    },
    onDragEnter(event) {
      this.B_isDragging = true;
      event.preventDefault();
    },
    onDragLeave(event) {
      this.B_isDragging = false;
      event.preventDefault();
    }
  },
  created() {
    // Les variables sont chargées mais pas le DOM
    this.B_SuperAdmin = this.$cookies.get("UserAdmin") == "true";
    this.B_UserEncoder = this.$cookies.get("UserEncoder") == "true";
    this.T_Period = this.$cookies.get("Period");
    this.L_UserID = this.$cookies.get("UserID");
    this.T_DateDisplay = this.IsisFct_Date2Display(this.T_DateSQL);
    this.T_DateDisplayRecall = this.IsisFct_Date2Display(this.T_DateSQLRecall);
    this.L_DuplicataID = this.$route.query.duplicata !== undefined ? parseInt(this.$route.query.duplicata) : 0;
  },
  mounted() {
    // Le DOM est chargé
    this.Fct_GetUsers();
    this.ProvidersLoad();
    this.Fct_GetAdr();
    this.Fct_GetCondPmt();

    const self = this;
    this.Fct_PeriodsLoad().then(function() {
      self.BudgetsLoadByYearAndUser(self.T_Period).then(function() {
        self.Fct_Loading();
      });
    });
  }
};
</script>

<style scoped>
.drop-area {
  border: 2px dashed #ccc;
  padding: 20px;
  text-align: center;
}

.icon {
  font-size: 48px; /* Taille de l'icône, ajustez selon vos besoins */
  color: #888; /* Couleur de l'icône */
}

.text {
  margin-top: 10px; /* Ajustez la marge selon vos besoins */
  color: #888; /* Couleur du texte */
}
</style>
